import { AppDispatch } from '../store';
import { notify } from '../reducers/notificationReducer';
import { toggleHerdMembership } from '../reducers/userReducer';
import posthog from './posthog';
import { UserState } from '../types/common';

/** Whether the user has joined the herd with the given id. */
export const isJoined = (
  subId: string | undefined,
  user: UserState | null | undefined
): boolean => {
  if (!subId || !user) return false;
  return (user.joinedHerds || []).includes(subId);
};

export const handleJoinHerd = async (
  id: string,
  herdName: string,
  dispatch: AppDispatch,
  user: UserState | null | undefined,
  // Mobile passes the login bottom sheet opener; without it (web) a
  // logged-out click stays a no-op.
  onAuthRequired?: (() => void) | null
): Promise<void> => {
  if (!user) {
    onAuthRequired?.();
    return;
  }
  const wasSubscribed = isJoined(id, user);
  try {
    // Membership + optimistic count updates + revert-on-error live here.
    await (dispatch as any)(toggleHerdMembership(id));
    posthog.capture('herd_subscription_toggled', {
      herd_name: herdName,
      action: wasSubscribed ? 'unsubscribed' : 'subscribed',
    });
    dispatch(
      notify(
        wasSubscribed ? `Unsubscribed from ${herdName}` : `Subscribed to ${herdName}!`,
        'success'
      )
    );
  } catch {
    // toggleHerdMembership already surfaced the error and reverted the optimistic state.
  }
};
